// extracted by mini-css-extract-plugin
export default {"date_wrapper":"styles_date_wrapper__b8ICH","divider":"styles_divider__Hk+8u","date":"styles_date__TuVEk"};